// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.league-bulk-player-status-info-modal .modal__container{
    padding: 16px 0 10px 0;
}

.league-bulk-player-status-info-modal__actions {
   display: flex;
   justify-content: flex-end;
   border-top: 1px solid var(--new-input-background-color);
   margin-right: 14px;
}

.league-bulk-player-status-info-modal__actions .primary-button{
    margin-top: 8px;
}

.league-bulk-player-status-info-modal__title{
    text-align: center;
}

.league-bulk-player-status-info-modal__text{
    padding: 0 39px;
    margin-top: 16px;
}

.league-bulk-player-status-info-modal__text.baloa-table{
    color: var(--primary-very-dark-color);
}

.league-bulk-player-status-info-modal__status-title.baloa-table{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.league-bulk-player-status-info-modal__status-container{
    padding: 0 39px;
    margin-top: 27px;
}

.league-bulk-player-status-info-modal__status-info{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
}

.league-bulk-player-status-info-modal__status-info:last-child{
    margin-bottom: 10px;
}

.league-bulk-player-status-info-modal__status-tag{
    border-radius: 25px;
    padding: 4px 6px;
    margin-right: 4px;
    background: var(--basic-gray-color);
}

.league-bulk-player-status-info-modal__status-tag.green{
    background: var(--new-green-color);
}

.league-bulk-player-status-info-modal__status-tag.orange{
    background: var(--new-yellow-color);
}

.league-bulk-player-status-info-modal__status-tag.baloa-username{
    color: var(--white-color);
}

.league-bulk-player-status-info-modal__status-text{
    width: 75%;
}

.league-bulk-player-status-info-modal__status-text.baloa-username{
    color: var(--black-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-bulk-player-status-info-modal/LeagueBulkPlayerStatusInfoModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;AAC1B;;AAEA;GACG,aAAa;GACb,yBAAyB;GACzB,uDAAuD;GACvD,kBAAkB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["\n.league-bulk-player-status-info-modal .modal__container{\n    padding: 16px 0 10px 0;\n}\n\n.league-bulk-player-status-info-modal__actions {\n   display: flex;\n   justify-content: flex-end;\n   border-top: 1px solid var(--new-input-background-color);\n   margin-right: 14px;\n}\n\n.league-bulk-player-status-info-modal__actions .primary-button{\n    margin-top: 8px;\n}\n\n.league-bulk-player-status-info-modal__title{\n    text-align: center;\n}\n\n.league-bulk-player-status-info-modal__text{\n    padding: 0 39px;\n    margin-top: 16px;\n}\n\n.league-bulk-player-status-info-modal__text.baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.league-bulk-player-status-info-modal__status-title.baloa-table{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.league-bulk-player-status-info-modal__status-container{\n    padding: 0 39px;\n    margin-top: 27px;\n}\n\n.league-bulk-player-status-info-modal__status-info{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 16px;\n}\n\n.league-bulk-player-status-info-modal__status-info:last-child{\n    margin-bottom: 10px;\n}\n\n.league-bulk-player-status-info-modal__status-tag{\n    border-radius: 25px;\n    padding: 4px 6px;\n    margin-right: 4px;\n    background: var(--basic-gray-color);\n}\n\n.league-bulk-player-status-info-modal__status-tag.green{\n    background: var(--new-green-color);\n}\n\n.league-bulk-player-status-info-modal__status-tag.orange{\n    background: var(--new-yellow-color);\n}\n\n.league-bulk-player-status-info-modal__status-tag.baloa-username{\n    color: var(--white-color);\n}\n\n.league-bulk-player-status-info-modal__status-text{\n    width: 75%;\n}\n\n.league-bulk-player-status-info-modal__status-text.baloa-username{\n    color: var(--black-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
